import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useUsersTabs = () => {
  const { t } = useTranslation('userManagement');

  return useMemo(
    () => [
      {
        label: t('systemUsers'),
      },
      {
        label: t('demoRECR8'),
      },
    ],
    [t],
  );
};

export default useUsersTabs;
